export default "__VITE_ASSET__CzNqKOOb__"